"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Progress.scss");
function Progress(props) {
    return (React.createElement("div", { className: 'spinner' },
        React.createElement("div", { className: 'rect1' }),
        React.createElement("div", { className: 'rect2' }),
        React.createElement("div", { className: 'rect3' }),
        React.createElement("div", { className: 'rect4' })));
}
exports.Progress = Progress;
//# sourceMappingURL=Progress.js.map